import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  Self,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  CustomConfigOption,
  CustomProductAttributeConfig,
} from 'ZalamoLibrary/src/lib/ui/products/types';
import {
  BehaviorSubject,
  ReplaySubject,
  Subject,
  combineLatest,
  distinctUntilChanged,
  filter,
  map,
  pluck,
  shareReplay,
  switchMap,
  tap,
} from 'rxjs';
import {
  Decoration,
  MineDecorationsGQL,
} from '../../../../../../../../lookbook-maestro/src/graphql';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import {
  UntypedFormArray,
  UntypedFormControl,
  NgControl,
} from '@angular/forms';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { HttpClient } from '@angular/common/http';

import {
  DecorationFieldType,
  DecorationForClient,
  GetDecorationDetailsForClientGQL,
} from '../../../../../../../../photographer-client/src/app/modules/look-book/graphql';
import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';
import {
  DecorationPreConfigForClient,
  LookBookOccasionForClient,
} from 'graphql/libs/look-book-client/src/graphql';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { hasSecondNamePersonalization } from 'projects/photographer-panel/src/app/modules/look-book/helpers';
import { LookBookOccasion } from '../../../../../../../../photographer-panel/src/graphql';
import { TypedFormBuilder } from 'ZalamoLibrary/src/lib/ui/form/TypedFormBuilder';

interface SingleOption {
  label: Array<{ language: string; text: string }>;
  description: Array<{ language: string; text: string }>;
  picked: boolean;
  paramId: string;
  icon: string;
  decorationId: string;
}

const cache = new Map();

@Component({
  selector: 'lib-album-decoration',
  templateUrl: './album-decoration.component.html',
  styleUrls: ['./album-decoration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AlbumDecorationComponent
  extends AbstractValueAccessor
  implements OnInit
{
  visibleOptions: Array<SingleOption> = [];
  files$ = new Subject();
  @Input() width;
  @Input() height;
  currentScene$ = new BehaviorSubject('');
  control = new UntypedFormControl();
  @Input() @Required currentValue;
  @Output() showPreloader = new EventEmitter<boolean>();
  firstLabelsLoad$ = new BehaviorSubject(true);
  occasion$ = new ReplaySubject<LookBookOccasionForClient>(1);
  model = this.form.typedGroup<{
    firstName: string;
    secondName: string;
    date: string;
    connector: string;
    decorationId: string;
    personalizationMode: 'fromType' | 'custom';
    lines: string[];
  }>({
    firstName: ['Natalia'],
    secondName: ['Daniel'],
    date: ['14.09.2022'],
    connector: ['i'],
    decorationId: [null],
    personalizationMode: ['fromType'],
    lines: new UntypedFormArray([]),
  });
  userDetails$ = this.model.valueChanges.pipe(
    map((v) => ({
      ...v,
      firstNameInitial: v.firstName[0],
      secondNameInitial: v.secondName[0],
    })),
  );
  @Required @Input() noDecorationOption: CustomConfigOption;
  personalizationMode = new UntypedFormControl('fromType');
  decorationDetails = this.form.typedGroup<{
    hasGold: boolean;
  }>({
    hasGold: [false],
  });
  hasFirstName$ = new BehaviorSubject(false);
  hasLastName$ = new BehaviorSubject(false);
  hasConnector$ = new BehaviorSubject(false);
  hasDate$ = new BehaviorSubject(false);
  @Output() newUrl = new EventEmitter();
  decoration: Decoration;
  decorationId: string;
  imageChanged = new Subject();
  drawDecoration = new Subject();
  updateInProgress = false;
  decorationsInPlay$ = new ReplaySubject<SingleOption[]>();
  decorations$ = this.decorationsInPlay$.pipe(
    switchMap((decorationIds) =>
      combineLatest(
        decorationIds.map(({ decorationId, icon, label }) =>
          this.getDecorationDetailsForClientGQL
            .fetch({ variables: { decorationId } })
            .pipe(
              pluck('data', 'getDecorationForClient'),
              map((decoration) => ({ ...decoration, icon, label })),
            ),
        ),
      ),
    ),
    shareReplay(1),
  );
  linesCount$ = new Subject();
  currentLinesConfig = [];
  iconSize$ = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((v) => (v.matches ? 150 : 200)));
  alreadyLoaded = false;

  occasionHasSecondName$ = this.occasion$.pipe(
    map((v) => hasSecondNamePersonalization(v as any as LookBookOccasion)),
    tap((hasSecondName) => {
      if (!hasSecondName) {
        this.model.patchValue({
          secondName: '',
          connector: '',
        });
      }
    }),
  );

  @Input() @Required set occasion(occasion: LookBookOccasionForClient) {
    this.occasion$.next(occasion);
  }

  @Input() set decorationPreConfig(preconfig: DecorationPreConfigForClient) {
    console.log(preconfig);
    if (preconfig) {
      this.model.patchValue(preconfig);
    }
  }

  get lines(): UntypedFormArray {
    return this.model.controls.lines as UntypedFormArray;
  }

  @Input() set currentScene(currentScene) {
    this.currentScene$.next(currentScene);
  }

  private _currentImage;

  get currentImage() {
    return this._currentImage;
  }

  @Input() set currentImage(value: string) {
    // if (!this._currentImage) {
    if (value.substr(0, 9) === 'blob:http') {
      return;
    }
    this._currentImage = value;
    this.imageChanged.next(undefined);
    // }
  }

  @Input() set baseImage(value: string) {
    // if (!this._currentImage) {
    if (!value) {
      return;
    }
    if (value.substr(0, 9) === 'blob:http') {
      return;
    }
    this._currentImage = value;

    this.currentScene$.next(this.currentScene$.value);
    this.imageChanged.next(undefined);

    // }
  }
  lineValuesCache = new Map<number, any>();
  set customLinesCount(linesCount) {
    this.lineValuesCache.set(this.lines.length, this.lines.value);
    while (this.lines.length > linesCount) {
      this.lines.removeAt(this.lines.length - 1);
    }
    for (let i = this.lines.length; i < linesCount; i++) {
      this.lines.push(new UntypedFormControl(''));
    }
    this.lines.patchValue(this.lineValuesCache.get(linesCount) || []);
  }

  @Input() set noDecoration(noDecoration) {
    if (noDecoration && !this.updateInProgress) {
      this.model.patchValue({ decorationId: null });
    }
  }

  @Input() set options(options: Array<CustomConfigOption>) {
    console.log(options);
    options = options.filter(({ active }) => active);
    this.visibleOptions = options.map((options) => ({
      label: options.label,
      description: options.description,
      icon: options.icon,
      width: options.width,
      height: options.height,
      decorationId: options.decorationId,
      picked:
        this.visibleOptions.find(({ picked }) => picked)?.paramId ===
        options.configId,
      paramId: options.configId,
    }));
    this.decorationsInPlay$.next(
      this.visibleOptions.filter(({ decorationId }) => decorationId),
    );
  }

  _config: Array<CustomProductAttributeConfig> = [];

  get config() {
    return this._config;
  }

  @Input() set config(config: Array<CustomProductAttributeConfig>) {
    this._config = config;
  }

  constructor(
    private mineDecorationsGQL: MineDecorationsGQL,
    @Self() @Optional() public ngControl: NgControl,
    private cd: ChangeDetectorRef,
    private form: TypedFormBuilder,
    private httpClient: HttpClient,
    private getDecorationDetailsForClientGQL: GetDecorationDetailsForClientGQL,
    public zalamoDialogService: ZalamoDialogService,
    private breakpointObserver: BreakpointObserver,
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      combineLatest([
        this.model.controls.decorationId.valueChanges,
        this.occasionHasSecondName$,
      ]).pipe(
        distinctUntilChanged(),
        RxjsOperators.filterTruthy(),
        switchMap(([decorationId, occasionHasSecondName]) =>
          this.decorations$.pipe(
            tap((decorations) => {
              const deco = decorations.find(
                (decoration) =>
                  decoration.decorationForClientId === decorationId,
              );
              if (deco) {
                const optionsAvailable = new Set<DecorationFieldType>();
                deco.fields.forEach((field) =>
                  field.types.forEach((type) => optionsAvailable.add(type)),
                );
                this.hasConnector$.next(
                  optionsAvailable.has(DecorationFieldType.Connector) &&
                    occasionHasSecondName,
                );
                this.hasDate$.next(
                  optionsAvailable.has(DecorationFieldType.Date),
                );
                this.hasFirstName$.next(
                  optionsAvailable.has(DecorationFieldType.FirstName),
                );
                this.hasLastName$.next(
                  optionsAvailable.has(DecorationFieldType.SecondName) &&
                    occasionHasSecondName,
                );
                this.customLinesCount = deco.fields.length;
              }
            }),
          ),
        ),
      ),
      this.valueSubject.pipe(
        filter(() => !this.updateInProgress && !this.alreadyLoaded),

        tap((newValue) => {
          console.log(newValue);
          this.updateInProgress = true;
          this.visibleOptions.forEach(({ paramId }, index, all) => {
            all[index].picked = paramId === newValue;
          });
          this.cd.detectChanges();
          if (newValue) {
            while (this.lines.length < newValue.lines?.length) {
              this.lines.push(new UntypedFormControl());
            }
          }
          if (newValue?.decorationId === this.noDecorationOption.configId) {
            newValue.decorationId = null;
          }
          this.model.patchValue(newValue);

          this.updateInProgress = false;
          this.alreadyLoaded = true;
        }),
      ),
      this.model.valueChanges.pipe(
        filter(() => !this.updateInProgress),
        tap((newValue) => {
          this.updateInProgress = true;
          this.writeValue(newValue);
          this.updateInProgress = false;
        }),
      ),
      this.currentScene$.pipe(
        filter(() => !!this.decoration),
        // switchMap(() => this.imageChanged),
        tap(() => this.drawDecoration.next(undefined)),
      ),
    );
  }

  pick(decoration: Partial<DecorationForClient>) {
    this.model.patchValue({
      decorationId: decoration.decorationForClientId,
    });
  }
}
